// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ToggleGroupContract = contract({
  name: "ToggleGroup",
  description: "A small set of mutually-exclusive (`type=\"single\"`) or independent (`type=\"multiple\"`) binary options that live side-by-side as a segmented control — viewport size picker (Mobile/Tablet/Desktop), text alignment, view density. Reads identically to a TabsList of the same size; reach for ToggleGroup when each option emits a value (like a form input) rather than swapping panels. Use Tabs for panel switching, Toggle for a single on/off.",
  import: "@gradeui/ui",
  aliases: ["toggle group","segmented control","segmented buttons","button group","pill group","view selector","segmented picker","segmentedcontrolios","segmented buttons group","rn segmented control"],
  subcomponents: ["ToggleGroupItem"],
  composesWith: ["Card (header controls)","Row","AppShellHeader chrome","settings panels"],
  styleDefaults: {"ToggleGroup":"flex items-center justify-center gap-1"},
  props: {
  "type": {
      schema: z.enum(["single", "multiple"]),
      design: "knob",
      description: "single picks one, multiple picks any number",
  },
  "value": {
      schema: z.union([z.string(), z.array(z.string())]).optional(),
      design: "knob",
      description: "controlled; matches `type` (string for single, string[] for multiple)",
  },
  "defaultValue": {
      schema: z.union([z.string(), z.array(z.string())]).optional(),
      design: "knob",
      description: "uncontrolled initial",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "size": {
      schema: z.enum(["2xs", "xs", "sm", "md", "lg, default md"]).optional(),
      design: "knob",
      description: "cascades to every ToggleGroupItem via context, matches Tabs/Button heights; 2xs/xs are the dense tool-panel sizes (2xs also drops text to text-2xs and icons to size-3 so labelled items read at panel density)",
  },
  "variant": {
      schema: z.enum(["default", "outline", "segmented"]).optional(),
      design: "knob",
      description: "segmented sits the items in a muted track with the active item as a soft raised pill, so it reads like a TabsList; reach for it in dense property panels (e.g. a Row/Stack direction toggle)",
  },
  "tooltip": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "when set, wraps the item in a Tooltip; required for icon-only items where the visible chrome doesn't carry a label",
  },
  "tooltipSide": {
      schema: z.enum(["top", "right", "bottom", "left\", default \"top"]).optional(),
      design: "knob",
      description: "side the tooltip renders on",
  },
  "tooltipDelay": {
      schema: z.number().optional(),
      design: "knob",
      description: "per-item delay override; falls back to the upstream TooltipProvider's delayDuration",
  },
  },
});
